<mbs-modal
  [loading]="loading"
  [title]="'wizards:addNetworkShare' | i18next: { format: 'title' }">
  <ng-container
    modal-body
    [formGroup]="form">
    <mbs-form-group [class.mb-0]="canUseShareTree">
      @if (!canUseShareTree) {
        <mbs-input
          formControlName="path"
          name="newPath"
          [id]="'new-path-input'"
          [label]="'wizards:addNetworkSharePath' | i18next"
          [placeholder]="'wizards:addNetworkSharePathPlaceholder' | i18next"
          [validationWhitespace]="true"
          (input)="resetTestResult()"></mbs-input>
      }

      @if (canUseShareTree) {
        <div
          #pathDropdown="ngbDropdown"
          ngbDropdown
          [container]="'body'"
          (openChange)="pathDropdownOpenChangeHandler($event)">
          <mbs-input
            #pathInput
            class="-no-arrow"
            formControlName="path"
            name="newPath"
            ngbDropdownAnchor
            [appendButtons]="[
              {
                text: '',
                icon: 'fa fa-chevron-down',
                id: elementSelectors.id.btnDropdown,
                disabled: form.get('path').disabled || credentialsLoading,
                type: 'secondary'
              },
              {
                text: 'Browse',
                id: elementSelectors.id.btnOpenTree,
                disabled: form.get('path').disabled,
                type: 'secondary'
              }
            ]"
            [id]="'new-path-input'"
            [label]="'wizards:addNetworkSharePath' | i18next"
            [placeholder]="'wizards:addNetworkSharePathPlaceholder' | i18next"
            [validationWhitespace]="true"
            (buttonClick)="pathNetworkTreeOpen($event)"
            (input)="resetTestResult()"></mbs-input>

          <div
            class="overflow-auto"
            ngbDropdownMenu
            style="max-height: 232px"
            [style.width.px]="pathDropdownWidth">
            @for (credentials of networkCredentialsList; track credentials.path) {
              <button
                ngbDropdownItem
                type="button"
                (click)="pathSelectHandler(credentials.path)">
                {{ credentials.path }}
              </button>
            }

            @if (networkCredentialsList.length) {
              <div class="dropdown-divider"></div>
            }

            <button
              class="text-primary"
              ngbDropdownItem
              type="button"
              (click)="manageNetworkCredentialsClickHandler()">
              Manage network credentials
            </button>
          </div>
        </div>
      }
    </mbs-form-group>

    @if (!canUseShareTree) {
      <div class="d-flex justify-content-end">
        <mbs-button
          [isCtrl]="true"
          [type]="'primary'"
          (click)="manageNetworkCredentialsClickHandler()">
          Manage network credentials
        </mbs-button>
      </div>
    }
  </ng-container>

  <ng-container modalFooter>
    <button
      class="btn btn-primary"
      type="button"
      (click)="addClickHandler()">
      {{ 'shared:buttons.add' | i18next: { format: 'title' } }}
    </button>
    <button
      class="btn btn-secondary"
      data-dismiss="modal"
      type="button"
      (click)="cancelClickHandler()">
      {{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}
    </button>
  </ng-container>
</mbs-modal>
